module.exports = __webpack_public_path__ + "static/img/tool_service_1.b32a5d1a.png";